
































import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import LivingPlace from './LivingPlace.vue'
import WorkPlace from './WorkPlace.vue'
import { beforeAddTask } from '@/utils/order'
import SprFestModal from '@/components/Modal/SprFestModal.vue'

@Component({
	name: 'addRiskTask',
	components: {
		LivingPlace,
		WorkPlace,
		PageLayout,
		SprFestModal,
	},
})
export default class addTaskPage extends Vue {
	private active: any = '1'
	private riskDisposal: any = false

	@Prop()
	private visible!: boolean

	private get isFirstVisit() {
		return this.active === '1'
	}

	private toggle(i: any) {
		this.active = i
	}

	private prevStep() {
		this.$emit('prevStep')
	}

	private activated() {
		this.riskDisposalInit()
	}

	private riskDisposalInit() {
		const riskDisposal = this.$ss.get('riskDisposal')
		this.riskDisposal = riskDisposal
	}

	private created() {
		this.riskDisposalInit()
	}

	private mounted() {
		beforeAddTask.call(this)
	}
}
